import React from "react";
import { motion } from "framer-motion";
import { Handshake } from "lucide-react";

/* ===== Images ===== */
import Aviral from "./MouImg/Aviral.png";
import Awadh from "./MouImg/Awadh.png";
import Chandigarh from "./MouImg/Chandigarh.png";
import EY from "./MouImg/EY.png";
import ICMR from "./MouImg/ICMR.png";
import IIMT from "./MouImg/IIMT.png";
import IvyCap from "./MouImg/Ivycap.png";
import NEN from "./MouImg/NEN.png";
import PCTE from "./MouImg/PCTE.png";
import Pbti from "./MouImg/Pbti.png";
import Punjab from "./MouImg/startupPunjab.png";
import TiE from "./MouImg/TiE.png";
import indiaacc from "./MouImg/indiaacc.png";
import MSME from "./MouImg/MSME.png";
import SirAuro from "./MouImg/SirAuro.png";
import sucseed from "./MouImg/sucseed.png";
import iitrpr from "../../images/iitrprlogoWBG.jpg";
import UKIndia from "./MouImg/UKIndia.png";
import EIL from "./MouImg/EIL.png";
import CFIIE from "./MouImg/CFIIE.png";
import CIBIOD from "./MouImg/CIBIOD.png";
import Bharat_Petroleum from "./MouImg/Bharat Petroleum.png";
import Bharat_Dynamics from "./MouImg/Bharat dynamics.png";
import WADHWANI from "./MouImg/WADHWANI.png";

// MoUS Partners
import CT_Group from "./MouImg/MoUS/CT Group.png";
import FQCI from "./MouImg/MoUS/FQCI.jpg";
import GMI_Infra from "./MouImg/MoUS/GMI-Infra.png";
import IET_Bhaddal from "./MouImg/MoUS/IET_Bhaddal.png";
import IFCI from "./MouImg/MoUS/IFCI.png";
import IITAC from "./MouImg/MoUS/IITAC.webp";
import IM_Punjab from "./MouImg/MoUS/IM_Punjab.png";
import IVY_Cap_Ventures from "./MouImg/MoUS/IVY Cap Ventures.png";
import MAHE from "./MouImg/MoUS/MAHE.jpg";
import NRL from "./MouImg/MoUS/NRL.jpg";
import Nirogya from "./MouImg/MoUS/Nirogya Life Line Foundation.png";
import PACE from "./MouImg/MoUS/PACE.png";
import SACC from "./MouImg/MoUS/SACC.jpg";
import Venture_Lab_Thappar from "./MouImg/MoUS/Venture_Lab_Thappar.png";
import AGB from "./MouImg/MoUS/agb.jpeg";
import Creed from "./MouImg/MoUS/creed.png";
import Zoho from "./MouImg/MoUS/Zoho_for_Startups_logo.png";
import NIELIT from "./MouImg/MoUS/nielit.jpeg";
import DRIF from "./MouImg/MoUS/drif.png";
import Filo from "./MouImg/MoUS/Filo.png";
import Toppan from "./MouImg/MoUS/Toppan.png";

import heroBackground from "../ProgramImages/partnership_image.jpeg";

const partners = [
  { img: iitrpr, name: "IIT Ropar" },
  { img: MSME, name: "Ministry of MSME" },
  { img: Punjab, name: "Startup Punjab" },
  { img: CIBIOD, name: "CIBiod PGIMER" },
  { img: ICMR, name: "ICMR" },
  { img: Bharat_Petroleum, name: "Bharat Petroleum" },
  { img: Bharat_Dynamics, name: "Bharat Dynamics" },
  { img: EIL, name: "Engineers India Ltd" },
  { img: UKIndia, name: "UK India Business Council" },
  { img: IvyCap, name: "IvyCap Ventures" },
  { img: sucseed, name: "SucSEED Innovation" },
  { img: indiaacc, name: "India Accelerator" },
  { img: EY, name: "Ernst & Young" },
  { img: WADHWANI, name: "Wadhwani Foundation" },
  { img: TiE, name: "TiE Chandigarh" },
  { img: Chandigarh, name: "Chandigarh Angels" },
  { img: NEN, name: "National Entrepreneurship Network" },
  { img: IIMT, name: "IIMT University" },
  { img: Pbti, name: "Punjab Biotech Incubator" },
  { img: IFCI, name: "IFCI" },
  { img: IITAC, name: "IITAC" },
  { img: IM_Punjab, name: "IM Punjab" },
  { img: IVY_Cap_Ventures, name: "IVY Cap Ventures" },
  { img: MAHE, name: "MAHE" },
  { img: NRL, name: "NRL" },
  { img: PACE, name: "PACE" },
  { img: Creed, name: "Creed" },
  { img: Awadh, name: "AWADH IIT Ropar" },
  { img: Nirogya, name: "Nirogya Life Line Foundation" },
  { img: SACC, name: "SACC" },
  { img: Venture_Lab_Thappar, name: "Venture Lab Thappar" },
  { img: AGB, name: "AGB" },
  { img: IET_Bhaddal, name: "IET Bhaddal" },
  { img: DRIF, name: "DRIF" },
  { img: FQCI, name: "FQCI" },
  { img: Zoho, name: "Zoho for Startups" },
  { img: CT_Group, name: "CT Group" },
  { img: NIELIT, name: "NIELIT" },
  { img: GMI_Infra, name: "GMI Infra" },
  { img: Filo, name: "Filo" },
  { img: Toppan, name: "Toppan" },

];

/* ===== Animation Variants ===== */
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.05 } }
};

const cardVariant = {
  hidden: { opacity: 0, y: 30, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: "easeOut" } }
};

export default function Mou() {
  return (
    <div className="bg-slate-50 min-h-screen font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900">

      {/* ===== HERO SECTION ===== */}
      <div className="relative h-[65vh] min-h-[500px] flex items-center justify-center overflow-hidden">

        {/* Background Image & Overlays */}
        <div className="absolute inset-0 z-0">
          <motion.div
            initial={{ scale: 1.1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 10, ease: "linear" }}
            className="w-full h-full"
          >
            <img
              src={heroBackground}
              alt="Partnership Background"
              className="w-full h-full object-cover"
            />
          </motion.div>
          {/* Overlays to ensure text readability */}
          <div className="absolute inset-0 bg-slate-900/60" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent" />
        </div>

        {/* Hero Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative z-10 text-center px-6 max-w-4xl mx-auto"
        >
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6 shadow-lg">
            <Handshake className="text-blue-400 w-4 h-4" />
            <span className="text-blue-50 text-xs font-bold tracking-widest uppercase">
              Global & National Ecosystem
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight drop-shadow-2xl">
            Strategic <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
              Partnerships
            </span>
          </h1>

          <p className="text-slate-200 text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed drop-shadow-md">
            Collaborating with government bodies, industry giants, and global investors to build a robust support system for deep-tech innovation.
          </p>
        </motion.div>
      </div>

      {/* ===== PARTNERS GRID SECTION ===== */}
      <section className="relative py-24 px-6 overflow-hidden bg-white">

        {/* Subtle Background Pattern */}
        <div className="absolute inset-0 opacity-[0.35]" style={{
          backgroundImage: 'radial-gradient(#93c5fd 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }} />

        {/* Soft Ambient Glows */}
        <div className="absolute top-[10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-blue-50 opacity-60 blur-3xl pointer-events-none" />
        <div className="absolute bottom-[10%] right-[-5%] w-[400px] h-[400px] rounded-full bg-cyan-50 opacity-50 blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto relative z-10">

          {/* Section Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              Our <span className="text-blue-600">Alliances</span>
            </h2>
            <div className="h-1 w-20 bg-gradient-to-r from-blue-600 to-cyan-400 mx-auto mt-4 rounded-full" />
          </motion.div>

          {/* Staggered Grid */}
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6"
          >
            {partners.map((partner, index) => (
              <motion.div
                key={index}
                variants={cardVariant}
                whileHover={{ y: -8, borderColor: '#3b82f6' }}
                className="group bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-300 flex flex-col items-center justify-center h-48 relative overflow-hidden cursor-default"
              >
                {/* Top accent bar (Animated on hover) */}
                <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-blue-600 to-cyan-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

                <div className="h-20 w-full flex items-center justify-center mb-4">
                  <img
                    src={partner.img}
                    alt={partner.name}
                    className="max-h-full max-w-full object-contain grayscale-[20%] group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                  />
                </div>

                <p className="text-xs font-bold text-slate-500 text-center uppercase tracking-wide group-hover:text-blue-700 transition-colors">
                  {partner.name}
                </p>

                {/* Subtle internal glow on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50/0 to-cyan-50/0 group-hover:from-blue-50/50 group-hover:to-cyan-50/50 transition-colors duration-300 pointer-events-none" />
              </motion.div>
            ))}
          </motion.div>

        </div>
      </section>

    </div>
  );
}